define('tracks/suit-settings',["require", "exports", "../dom", "../util/http", "../views/autocomplete", "../views/text-setting"], function (require, exports, dom_1, http_1, autocomplete_1, text_setting_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = void 0;
    function init(trackId, userId) {
        var suitElement = (0, dom_1.q)(".suit")[0];
        if (!suitElement)
            return;
        // Initialize text setting component
        var textSetting = new text_setting_1.TextSetting({
            element: suitElement,
            selectMode: text_setting_1.TextSettingMode.SelectAll,
            closeOnBlur: false,
            save: function (suit) {
                return (0, http_1.postJson)("/tracks/" + trackId + "/suit", suit)
                    .catch(function (e) { throw new Error("Failed to save suit: " + e); });
            }
        });
        // Initialize suit autocomplete
        var input = document.getElementById("track-suit-input");
        if (input) {
            var url = userId ? "/suits.json?userid=" + userId : "/suits.json";
            (0, http_1.getJson)(url).then(function (all) {
                var ac = new autocomplete_1.Autocomplete({
                    input: input,
                    items: all,
                    minLength: 0,
                    display: function (suit) { return suit.company + " " + suit.name; },
                    filter: function (suit) { return suit.company + " " + suit.name; },
                    value: function (suit) { return suit.name; }
                });
                ac.updates.subscribe(function (suit) {
                    textSetting.commit(suit.name);
                });
            });
        }
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/tracks/suit-settings.js.map;
